var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAirPressureIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.3 20.84L40.76 17.14L40.78 17.12C42.7853 20.2126 43.8969 23.7993 43.9922 27.4839C44.0875 31.1685 43.1627 34.8078 41.32 38C40.9676 38.6104 40.4601 39.1169 39.849 39.4681C39.2379 39.8193 38.5448 40.0028 37.84 40H10.14C9.44194 39.9958 8.75714 39.809 8.15366 39.4581C7.55017 39.1072 7.04902 38.6046 6.69999 38C4.47949 34.1148 3.62614 29.5971 4.27643 25.1696C4.92672 20.7421 7.04308 16.6607 10.287 13.578C13.5309 10.4954 17.7149 8.58973 22.1698 8.16587C26.6246 7.74201 31.093 8.82443 34.86 11.24L31.16 13.7C28.084 12.1613 24.594 11.6547 21.2075 12.2554C17.8209 12.8561 14.7181 14.5321 12.359 17.0349C9.99981 19.5377 8.50996 22.734 8.11027 26.1501C7.71058 29.5662 8.42233 33.0202 10.14 36H37.86C39.1816 33.7066 39.9136 31.1212 39.9904 28.4754C40.0671 25.8297 39.4863 23.2061 38.3 20.84ZM22.4782 31.6883C21.9926 31.487 21.5515 31.1919 21.18 30.82C20.8081 30.4485 20.5131 30.0074 20.3118 29.5218C20.1105 29.0362 20.0069 28.5157 20.0069 27.99C20.0069 27.4644 20.1105 26.9439 20.3118 26.4583C20.5131 25.9727 20.8081 25.5315 21.18 25.16L38.16 13.84L26.84 30.82C26.4685 31.1919 26.0274 31.487 25.5418 31.6883C25.0562 31.8896 24.5357 31.9932 24.01 31.9932C23.4843 31.9932 22.9638 31.8896 22.4782 31.6883Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirPressureIcon);
export default __webpack_public_path__ + "static/media/airPressureIcon.4782fe1b4124a1c4bfdbaf8ec7fec653.svg";
export { ForwardRef as ReactComponent };